import { Link, useLocation } from "react-router-dom";
import { ShoppingCart, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";

const SHOW_ON = ["/store", "/herbs", "/shop"];

export const MobileCartBar = () => {
  const { count } = useCart();
  const { pathname } = useLocation();
  const visible = count > 0 && SHOW_ON.some((p) => pathname === p || pathname.startsWith(p + "/"));
  if (!visible) return null;
  return (
    <div className="md:hidden fixed bottom-[60px] inset-x-0 z-40 p-3" data-testid="mobile-cart-bar">
      <Link
        to="/cart"
        className="flex items-center justify-between bg-primary text-white rounded-full px-5 py-3.5 shadow-xl shadow-emerald-900/30 active:scale-[0.98] transition-transform"
        data-testid="mobile-cart-bar-link"
      >
        <span className="flex items-center gap-2 font-semibold text-sm">
          <ShoppingCart className="w-4 h-4" />
          View Cart
        </span>
        <span className="flex items-center gap-2 text-sm">
          <span className="bg-white/20 rounded-full px-2.5 py-0.5 font-bold" data-testid="mobile-cart-bar-count">{count} item{count > 1 ? "s" : ""}</span>
          <ArrowRight className="w-4 h-4" />
        </span>
      </Link>
    </div>
  );
};
